<template>
  <div class="b-menu-drop-target-indicator" :style="[position]" :class="classes"></div>
</template>

<script>
import StoreHelper from '../store/helper'
import PositionManager from '../util/PositionManager'
import StyleConverter from '../util/StyleConverter'

import _ from 'lodash'

export default {
  name: 'b-menu-drop-target-indicator',
  computed: {
    classes () {
      return {
        'b-menu-drop-target-indicator--active': this.active
      }
    },
    active () {
      return StoreHelper.isDragInProgress() || StoreHelper.isDropTargetDefined()
    },
    position () {
      const index = StoreHelper.getDropIndicatorIndex()
      if (_.lt(index, 0)) return

      const position = PositionManager.calculateDropIndicatorPosition(index)
      return StyleConverter.createMenuItemTransformation(position)
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-drop-target-indicator {
  position: absolute;
  z-index: 200;
  top: 50%;
  left: 50%;
  visibility: visible;
  margin: -10px;
  height: 20px;
  width: 20px;
  pointer-events: none;

  &:after {
    transition: all 300ms ease 100ms;
    content: '';
    position: absolute;
    top: 0;
    z-index: 100;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #63B32E;
    height: 8px;
    width: 8px;
    margin: auto;
    border-radius: 50%;
    max-height: 0;
    max-width: 0;
    opacity: 0;
  }

  &--active:after {
    max-height: 8px;
    max-width: 8px;
    opacity: 1;
  }
}
</style>
